// extracted by mini-css-extract-plugin
export default {"tableHeader":"ProductSales_tableHeader__vq5jS","buttonFont":"ProductSales_buttonFont__c2MWE"};